module.exports = __webpack_public_path__ + "static/media/placas (4).66f33501.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/placas (4).jpg
// module id = 354
// module chunks = 0